//
//
//
//
//
//
//
//
//

export default {
      data: function() {
          return {
              today: new Date(),
              startDate: '2017-4-10',
              endDate: '2018-11-9',
              currentDate: '2017-8-31'
          };
      },
      methods: {
          setTime: function(e) {
              console.log(e);
          }
      }
};



// WEBPACK FOOTER //
// ./example/pages/infinite-calendar.vue